module.exports = __webpack_public_path__ + "img/Training-Unsel.ab596ced.svg";